import locale from "localization";
import styles from "../delivery-log.module.scss";
export const fuelColumns = [
  {
    key: "product",
    tdClassName: styles.alignToTop,
    text: locale.product,
    style: {
      width: "100px",
    },
  },
  {
    key: "quantityBeforeReceiving",
    text: locale.quantityBeforeReceiving,
  },
  {
    key: "quantityDelivered",
    text: locale.quantityDelivered,
  },
  {
    key: "quantityAfterReceiving",
    text: locale.quantityAfterReceiving,
  },
  {
    key: "actions",
    text: locale.actions,
    tdClassName: styles.alignToCenter,
    style: {
      marginBottom: "1em",
    },
  },
];

export const nonFuelColumns = [
  {
    key: "sku",
    text: locale.sku,
    tdClassName: styles.alignToCenter,
  },
  {
    key: "product",
    text: locale.product,
    tdClassName: styles.alignToCenter,
  },
  {
    key: "variant",
    text: locale.variant,
    tdClassName: styles.alignToCenter,
  },
  {
    key: "category",
    text: locale.productCategory,
  },
  {
    key: "quantityBeforeReceiving",
    text: locale.quantityBeforeReceiving,
    style: {
      margin: "10px 0px",
    },
  },
  {
    key: "quantityDelivered",
    text: locale.quantityDelivered,
  },
  {
    key: "quantityAfterReceiving",
    text: locale.quantityAfterReceiving,
  },
  {
    key: "variance",
    text: locale.variance,
    tdClassName: styles.alignToCenter,
  },
  {
    key: "actions",
    text: locale.actions,
    tdClassName: styles.alignToCenter,
  },
];
